import * as preact from "preact";
import Slider from "react-slick";
import { $$ } from "../../Core/Common";
import { BaseComponent, IBaseComponentProps } from "../../Common/BaseComponent/BaseComponent";
import { VideoPlayPanel } from "../../Common/VideoPlayPanel/VideoPlayPanel";
import { $$requestManager } from "../../Core/RequestManager";

interface IState
{
    events: any[]
}

interface IProps extends IBaseComponentProps
{
    onEventSelected?: (eventId?: string) => void;
    onTopicSelected?: (topicId?: string) => void;
}

export class EventsOfDay extends BaseComponent<IProps, IState>
{
    constructor(props)
    {
        super(props);
        this.setState({ events: [] });
    }

    public override componentDidMount(): void
    {
        super.componentDidMount();
        this._load();
    }

    private _load(): void
    {

        let date = new Date();
        let monthDay = date.getMonth() + 1 + "" + ("0" + date.getDate()).slice(-2);
        $$requestManager.execute("api/event/loadfullevents", { MonthDay: monthDay, Grouping: 4 }, this._onLoadFullEvents.bind(this))
    }

    private _onLoadFullEvents(events)
    {
        this.setState({ events: events });
    }

    private _onEventClick(eventId: string)
    {
        if (this.props.onEventSelected)
        {
            this.props.onEventSelected(eventId);
        }
    }
    /*
    private _onTopicClick(evtArgs)
    {
        let target = evtArgs.target;
        let pnlTopic = $$.getParent(target, "span", "topic");
        if (pnlTopic)
        {
            let topicId = pnlTopic.dataset.key;

            if (this.props.onTopicSelected)
            {
                this.props.onTopicSelected(topicId);
            }
        }
    }
    */
    public render()
    {
        if (!this.state.events || this.state.events.length == 0)
        {
            return null;
        }

        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 7000
        };

        let date = new Date();
        let onEventClick = this._onEventClick.bind(this);

        return (
            <div class="spotlightWrapper">
                <div style="text-align: center; font-size: 22px; padding: 10px; margin:5px; margin-bottom: 25px; background-color: #dbe7f2">This Day in History - {date.toLocaleString("en-US", { month: "long", day: "numeric" })}</div>

                <Slider {...settings}>
                    {
                        this.state.events?.map((event, index) =>
                        {
                            return (
                                <div>
                                    <div class="spotlight">

                                        <div class="spotTitle" onClick={()=> onEventClick(event.Id)}><em>{$$.flexDateToDate(event.Start).getFullYear()}</em> - {event.Name}</div>

                                        <VideoPlayPanel Videos={event?.Videos?.length > 0 ? [event.Videos[0]] : null} HideDescription={true} HiResImages={true} />
                                        <div onClick={() => onEventClick(event.Id)} dangerouslySetInnerHTML={{ __html: event.Details }} />


                                    </div>
                                </div>);
                        })
                    }
                </Slider>
            </div>);
    }
}